import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

const ID_CHECK_PATH = '/funding-requirements/id-check';

type TIdCheckStepProps = { status: TFundingRequirementStatus };

export const IdCheckStep = ({ status }: TIdCheckStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.id_check_step.list_title"
                    defaultMessage="Complete your ID check"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href={ID_CHECK_PATH}
            status={status}
            completedView={
                <Text className="text-m font-med text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.id_check_step.list_title"
                        defaultMessage="Complete your ID check"
                    />
                </Text>
            }
        />
    );
};
